module.exports = __webpack_public_path__ + "img/noises-20.bfc79b03.jpg";